import { render, staticRenderFns } from "./ClassRelation.vue?vue&type=template&id=4423c949&scoped=true&"
import script from "./ClassRelation.vue?vue&type=script&lang=js&"
export * from "./ClassRelation.vue?vue&type=script&lang=js&"
import style0 from "./ClassRelation.vue?vue&type=style&index=0&id=4423c949&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423c949",
  null
  
)

export default component.exports